import {
  IoAddCircleSharp,
  IoBook,
  IoDocuments,
  IoFileTrayFull,
  IoFlask,
  IoFolder,
  IoFolderOpen,
  IoHome,
  IoInformationCircleOutline,
  IoMail,
  IoPeople,
  IoSchool,
  IoServer,
} from 'react-icons/io5'

import { baseUrl } from '@/constants'

const config = [
  {
    header: 'Geral',
    items: [
      { icon: <IoHome />, title: 'Início', href: '/' },
      {
        icon: <IoMail />,
        flag: 'messages',
        title: 'Mensagens',
        href: '/mensagens',
      },
      {
        icon: <IoFileTrayFull />,
        flag: 'comunicados',
        title: 'Comunicados',
        href: '/comunicados',
      },
      {
        icon: <IoInformationCircleOutline />,
        title: 'Jornada Tecnológica',
        href: '/jornada-tenologica',
      },
    ],
  },
  {
    header: 'Educacional',
    items: [
      {
        title: 'Turmas',
        icon: <IoPeople />,
        href: '/turmas',
      },
      {
        title: 'Biblioteca de Conteúdo',
        icon: <IoFolder />,
        href: '/conteudo',
      },
      {
        title: 'Atividades',
        icon: <IoDocuments />,
        href: '/atividades',
      },
      {
        icon: <IoSchool />,
        title: 'Painel dos Professores',
        href: '/painel',
        flag: 'painel',
      },
    ],
  },
  {
    header: 'Avaliações',
    items: [
      {
        icon: <IoServer />,
        title: 'Banco de itens',
        href: 'exercicios/questoes',
      },
      {
        icon: <IoAddCircleSharp />,
        title: 'Criar item',
        href: 'exercicios/nova-questao',
      },
      {
        icon: <IoFolderOpen />,
        title: 'Avaliações',
        href: 'exercicios/provas',
      },
      {
        icon: <IoAddCircleSharp />,
        title: 'Criar Avaliação',
        href: 'exercicios/nova-prova',
      },
    ],
  },
  {
    header: 'Links Úteis',
    items: [
      {
        icon: <IoBook />,
        title: 'Minha Biblioteca',
        href: `${baseUrl}my-libraries`,
      },
      {
        icon: <IoFlask />,
        title: 'Reserva de Espaços Laboratoriais',
        href: 'https://trivento.zeev.it/2.0/anonymous?c=ryiSyWUNoMJXvlUdHxA4oGVWqCCdTyMtY8DGl3WUyRGaFk8OdxiVzP476Z1jcNDN4zpFLw%2F4QKakFiEDPDWrVUUGajVGJbL1GCYKDYk4HSk%3D',
      },
      {
        icon: <IoFlask />,
        title: 'Medicina - Reserva de Espaços Laboratoriais',
        href: 'https://links.triventoeducacao.com.br/agendamento_lab_Medicina',
      },
    ],
  },
]

export default config
